enum RoutePaths {
  Home = '/',
  CallbackRequests = '/callback-requests',
  ManageUsers = '/users/manage',
  AddUser = '/users/add',
  EditUser = '/users/:id/edit',
}

export default RoutePaths;
